import {
  FETCH_EMAIL_TEMPLATES_REQUEST,
  FETCHING_EMAIL_TEMPLATES_SUCCEDDED,
  FETCHING_EMAIL_TEMPLATES_FAILED,
  FETCH_EMAIL_TEMPLATE_REQUEST,
  FETCHING_EMAIL_TEMPLATE_SUCCEDDED,
  FETCHING_EMAIL_TEMPLATE_FAILED,
  INVALIDATE_EMAIL_TEMPLATES,
  FETCH_DEFAULT_EMAIL_TEMPLATE_REQUEST, 
  FETCHING_DEFAULT_EMAIL_TEMPLATE_SUCCEDDED, 
  FETCHING_DEFAULT_EMAIL_TEMPLATE_FAILED

} from "src/redux/actions/actionTypes";
import {
  FetchEmailTemplatesRequest,
  FetchEmailTemplatesResponse,
  FetchEmailTemplatesErrorResponse,
  FetchEmailTemplateRequest,
  FetchEmailTemplateResponse,
  FetchEmailTemplateErrorResponse,
  FetchDefaultEmailTemplateResponse,
  FetchDefaultEmailTemplateErrorResponse

} from "src/types/emailTemplates.js";

interface TemplatesItem {
  loading: boolean;
  loadMore: boolean;
  invalidated: boolean;
  currentPage: number;
  totalPages: number;
  recordsPerPage: number;
  hasMoreItems: boolean;
  items: any;
  error: null;
  template: Templates;
  defaultTemplate : DefaultTemplate;
}
interface DefaultTemplate {
  loading: boolean;
  item: any;
  error : null
}
interface Templates {
  loading: boolean;
  creating: boolean;
  error: null;
  deleting: boolean;
  uploading: boolean;
  media: {
    image: [];
    error: null;
  };
}
const initialLayoutState: TemplatesItem = {
  loading: false,
  loadMore: true,
  invalidated: true,
  currentPage: -1,
  totalPages: 0,
  recordsPerPage: 0,
  hasMoreItems: false,
  items: [],
  error: null,
  template: {
    loading: false,
    creating: false,
    error: null,
    deleting: false,
    uploading: false,
    media: {
      image: [],
      error: null,
    },
  },
  defaultTemplate: {
    loading: false,
    item: null,
    error: null,
  },
};

export function emailTemplatesReducer(state = initialLayoutState, action: any) {
  switch (action.type) {
    case FETCH_EMAIL_TEMPLATES_REQUEST:
      return {
        ...state,
        loading: true,
        invalidated: true,
      };

    case FETCHING_EMAIL_TEMPLATES_SUCCEDDED: {
      const result = action.payload as FetchEmailTemplatesResponse;

      var loadMore = result.currentPage <= result.totalPages;
      var records = result.records || [];
      var items = [...state.items, ...records];

      items = items.reduce((x, y) => {
        var index = x.findIndex((e) => {
          return e.id == y.id;
        });

        if (index < 0) {
          return [...x, y];
        } else {
          x[index] = y;
          return x;
        }
      }, []);

      items = items.reduce((item, template) => {
        if (template.default) {
          return [template, ...item];
        }
        return [...item, template];
      }, []);

      return {
        ...state,
        loading: false,
        items: items,
        currentPage: result.currentPage,
        totalPages: result.totalPages,
        loadMore: loadMore,
        invalidated: false,
        hasMoreItems: result.currentPage < result.totalPages - 1,
      };

    }

    case FETCHING_EMAIL_TEMPLATES_FAILED: {
      const {error} = action.payload as FetchEmailTemplatesErrorResponse;

      return {
        ...state,
        loading: false,
        invalidated: false,
        error: error,
      };
    }

    case FETCH_EMAIL_TEMPLATE_REQUEST: {
      const {id} = action.payload as FetchEmailTemplateRequest;

      return {
        ...state,
        template: {
          ...state.template,
          [id]: {
            fetching: true,
            fetched: false
          },
        },
      };
    }  

    case FETCHING_EMAIL_TEMPLATE_SUCCEDDED: {
      const {id, template} = action.payload as FetchEmailTemplateResponse;

      return {
        ...state,
        template: { 
          ...state.template,
          [id]: {
            item: template,
            fetching: false,
            fetched: true,
          },
        },
      };

    }

    case FETCHING_EMAIL_TEMPLATE_FAILED: {
      const {id, error} = action.payload as FetchEmailTemplateErrorResponse;

      return {
        ...state,
        template: {
          ...state.template,
          [id]: {
            error: action.payload.error,
            fetching: false,
            fetched: false
          },
        },
      };

    }

    case INVALIDATE_EMAIL_TEMPLATES: {
      return {
        ...state,
        loading: false,
        invalidated: true,
        items: [],
      };
    }

    case FETCH_DEFAULT_EMAIL_TEMPLATE_REQUEST: {
      return {
        ...state,
        defaultTemplate: {
          ...state.defaultTemplate,
          loading: true,
        },
      };
    }

    case FETCHING_DEFAULT_EMAIL_TEMPLATE_SUCCEDDED:{
      const response = action.payload as FetchDefaultEmailTemplateResponse;

      return  {
        ...state,
        defaultTemplate: {
          ...state.defaultTemplate,
          item: response,
          loading: false,
          error: null,
        },
      };
    }
    case FETCHING_DEFAULT_EMAIL_TEMPLATE_FAILED:{
      const {error} = action.payload as FetchDefaultEmailTemplateErrorResponse;

      return {
        ...state,
        defaultTemplate: {
          ...state.defaultTemplate,
          loading: false,
          error: error,
        },
      };
    }
    
    default: {
      return state;
    }
  }
}
